import { GridHelper, Group } from 'three';

export function buildGrid(
  size: number,
  divisions: number,
  color = 0x73838c
): Group {
  const grid1 = new GridHelper(size, divisions, color, color);
  const grid2 = new GridHelper(size, divisions * 2, color, color);
  grid1.material.depthTest = false;
  grid2.material.depthTest = false;
  grid1.material.transparent = true;
  grid2.material.transparent = true;
  grid1.material.opacity = 0.5;
  grid2.material.opacity = 0.25;
  const group = new Group();
  group.add(grid1, grid2);
  return group;
}
